import { IPersonel } from '../../../interfaces'
import http from '../../HttpConfig'
import { APIS_ENDPOINTS } from '../../SERVICE-CONSTANTS'

const personel_endpoints = APIS_ENDPOINTS.personel

export const request_upsertpersonnel = async ({
  firstName,
  lastName,
  email,
  phone,
  role,
  confirmPassword,
  password,
  profileImageFile,
  roleLevel,
  roleLevelSecond,
}: IPersonel) => {
  var formData = new FormData()
  formData.append('FirstName', firstName)
  formData.append('LastName', lastName)
  formData.append('Phone', phone)
  formData.append('Email', email)
  formData.append('RoleLevel', roleLevel as any)
  formData.append('RoleLevelSecond', roleLevelSecond as any)

  for (var i = 0; i < role.length; i++) {
    formData.append('Role', role[i])
  }
  formData.append('Password', password ?? '')
  formData.append('ConfirmPassword', confirmPassword ?? '')
  formData.append('ProfileImageFile', profileImageFile ?? '')
  return http.post(personel_endpoints.upsertpersonnel, formData)
}

export const request_editpersonnel = async ({
  firstName,
  lastName,
  email,
  phone,
  id,
  profileImageFile,
  role,
  roleLevel,
  roleLevelSecond,
}: IPersonel) => {
  var formData = new FormData()
  formData.append('FirstName', firstName)
  formData.append('LastName', lastName)
  formData.append('Phone', phone)
  formData.append('Email', email)
  if (roleLevel) {
    formData.append('RoleLevel', roleLevel as any)
  }
  if (roleLevelSecond) {
    formData.append('RoleLevelSecond', roleLevelSecond as any)
  }
  if (id !== undefined) {
    formData.append('Id', id.toString())
  }
  if (role) {
    for (var i = 0; i < role.length; i++) {
      formData.append('Role', role[i])
    }
  }
  formData.append('ProfileImageFile', profileImageFile ?? '')

  return http.put(personel_endpoints.editpersonnel, formData)
}

export const request_getpersonnel = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    personel_endpoints.datatable +
    `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}

export const request_blockpersonnel = async (id: number) => {
  var formData = new FormData()
  formData.append('Id', id.toString())

  return http.post(personel_endpoints.blockUser, formData)
}

export const request_unblockpersonnel = async (id: number) => {
  var formData = new FormData()
  formData.append('Id', id.toString())

  return http.post(personel_endpoints.unBlockUser, formData)
}

export const request_changepasswordbyadmin = async ({
  userId,
  password,
  confirmPassword,
}: {
  userId: number
  password: string
  confirmPassword: string
}) => {
  var formData = new FormData()
  formData.append('UserId', userId.toString())
  formData.append('Password', password)
  formData.append('ConfirmPassword', confirmPassword)

  return http.put(personel_endpoints.changepasswordbyadmin, formData)
}
export const request_changepersonelpass = async ({
  userId,
  password,
  confirmPassword,
}: {
  userId: number
  password: string
  confirmPassword: string
}) => {
  var formData = new FormData()
  formData.append('UserId', userId.toString())
  formData.append('Password', password)
  formData.append('ConfirmPassword', confirmPassword)

  return http.put(personel_endpoints.personelpass, formData)
}
export const request_changeestatepass = async ({
  userId,
  password,
  confirmPassword,
}: {
  userId: number
  password: string
  confirmPassword: string
}) => {
  var formData = new FormData()
  formData.append('UserId', userId.toString())
  formData.append('Password', password)
  formData.append('ConfirmPassword', confirmPassword)

  return http.put(personel_endpoints.estatepass, formData)
}

export const request_removeImageProfile = async (id: number) => {
  return http.post(personel_endpoints.removeImageProfile + '?Id=' + id)
}
export const request_removehiddenprofileimage = async (id: string | number) => {
  return http.post(personel_endpoints.deleteHiddenProfile + '?Id=' + id)
}
export const request_removePersonelRole = async ({ id, role }: { id: number; role: string }) => {
  const formData = new FormData()
  formData.append('Id', id as any)
  formData.append('Role', role)
  return http.post(personel_endpoints.removePersonelRole, formData)
}

export const request_getUsersByRole = async (RoleName: string) => {
  return http.get(
    personel_endpoints.getusersbyrole +
    `${RoleName != undefined ? `?RoleName=${RoleName}` : '?RoleName=NULL'}`
  )
}

export const request_addclaim = async (data: any) => {
  const formData = new FormData();
  formData.append('UserId', data.UserId)

  if (data?.selectedUserClaimValues?.length !== 0) {
    for (var i = 0; i < data?.selectedUserClaimValues?.length; i++) {
      formData.append('selectedUserClaimValues', data?.selectedUserClaimValues?.[i])
    }
  }
  return http.post(
    personel_endpoints.addclaim, formData
  )
}

export const request_finduserincludeuserclaimsasync = async (id: string) => {
  return http.get(
    personel_endpoints.finduserincludeuserclaimsasync + '?userId=' + id
  )
}
